import { render, staticRenderFns } from "./parts-locations-sms-email-card.vue?vue&type=template&id=052ac286&scoped=true&"
import script from "./parts-locations-sms-email-card.vue?vue&type=script&lang=js&"
export * from "./parts-locations-sms-email-card.vue?vue&type=script&lang=js&"
import style0 from "./parts-locations-sms-email-card.vue?vue&type=style&index=0&id=052ac286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ac286",
  null
  
)

export default component.exports